
import * as d3 from 'd3'
import * as $ from 'jquery'
import FastClick from 'fastclick'

var InfoGraphic = {
	ipad: false,
	style: {
		width: $(window).width(),
		height: $(window).innerHeight(),
		offset_y: 150,
		offset_x: 300,
		zoom: 1,			// viewport代わり
	},
	year: {
		sel: 0,
		name: 'year_1974',
		label: [
			"year_1974",
			"year_1984",
			"year_1994",
			"year_2004",
			"year_2014",
			"year_2022",
		],
	},
	init: function () {
		// setdom
		this.svg = d3.select('#svg')						//svg
		this.viewport = this.svg.select('#viewport')		// g
		this.information = this.viewport.select('#info')	// g

		window.scrollTo(0, 0);

		// logo animation
		this.logo = new InfoGraphic.logo();
		this.logo.init();

		// callback
		this.data = this.data();
		this.data.load(function () {
			InfoGraphic.deffered();
		});

		this.bind();
		this.copyright();

	},
	bind: function () {
		// fastclick
		FastClick.attach(document.body);	 // fastclick.js

		// resize
		$(window).on('resize', this.resize)

		// scroll cancell
		document.addEventListener('touchmove', bindTouch, {passive: true});
		function bindTouch(event) {
			if ($(event.target).attr('class') !== 'js_touch_enabled') {
				event.preventDefault();
			}
		}

	},
	deffered: function () {
		this.resize();

		this.vegetables = new InfoGraphic.vegetables();
		this.vegetables.init();

		// map
		this.map = new InfoGraphic.map();
		this.map.init();

		// timemachine
		var timemachine = new InfoGraphic.timemachine();
		timemachine.init();

		// bubble
		this.bubble = new InfoGraphic.bubble();
	},
	resize: function () {
		var self = InfoGraphic;
		self.style.width = $(window).width();
		self.style.height = $(window).height();

		self.detailsize = Math.min(self.style.width, self.style.height) - 300;
		self
			.svg
			.attr('width', self.style.width)
			.attr('height', self.style.height)

		InfoGraphic.copyright()
	},
	copyright: function () {
		d3.select('#copyright')
			.selectAll('.text')
			.attr('transform', 'translate(' + (this.style.width / 2) + ', ' + (this.style.height - 80) + ')')

		d3.select('#copyright')
			.selectAll('.logo')
			.attr('transform', 'translate(' + (this.style.width - 200) + ', ' + (this.style.height - 70) + ')')
			.on('click', function () {

			})
	}
}

InfoGraphic.setting = {
	selected: 0,
	name: {
		en: ["tomato", "potato", "daikon", "nasu", "pepper"],
		jp: ["トマト", "じゃがいも", "大根", "ナス", "ピーマン"]
	},
	year: {
		selected: 0,
		name: ["year_1974", "year_1984", "year_1994", "year_2004", "year_2014", "year_2022"],
	},
	vegetables: {
		selected: 0,
		name: {
			en: ["tomato", "potato", "daikon", "nasu", "pepper"],
			jp: ["トマト", "じゃがいも", "大根", "ナス", "ピーマン"]
		}
	},
	pref: {
		selected: 0,
		name: null
	}
}

InfoGraphic.vegetables = function () {
	var root = InfoGraphic;
	var obj = {
		selected: 0,
		selected_name: 'potato',
		name: {
			en: ["tomato", "potato", "daikon", "nasu", "pepper"],
			jp: ["トマト", "じゃがいも", "大根", "ナス", "ピーマン"]
		},
		init: function () {
			this.selector = new this.selector();
		},
		select: function (name, i) {
			this.selected_name = name;
			obj.selected = i;
			if (root.map.is_zoom) { root.map.zoom_out(); }
			root.map.draw(true)
			this.selector.set()
		},
		selector: function () {
			var vegetableObj = d3.select('#select_vegetables');
			var arrow_obj = {
				obj: vegetableObj.select('.arrow'),
				x: 0,
				y: 68
			}
			var bind = function () {
				$(window).on('resize', adjust)
			}
			var adjust = function () {
				if (root.style.width / 840 <= 1) {
					functions.zoom = root.style.width / 840
				}
				var thisX = (root.style.width - (functions.length * 160) - 40)
				var thisY = (root.style.height - 280)
				vegetableObj
					.attr('transform', 'translate(' + thisX + ', ' + thisY + ') scale(1)')

				arrow_obj.x = (functions.length - 1) * 160 - 24;
				arrow_obj.obj.attr('transform', 'translate(' + arrow_obj.x + ', ' + arrow_obj.y + ')')

			}
			var functions = {
				offset: 20,
				zoom: 1,
				is_open: null,
				build: function (thisArray) {
					vegetableObj
						.style('display', 'block')
						.selectAll('.vegetable')
						.data(thisArray)
						.attr('opacity', function (d, i) {
							return .1;
						})
						.attr('transform', function (d, i) { return 'translate(' + i * 160 + ', 0)' })
						.on('click', function (d, i) {
							if (functions.is_open) {
								obj.select(d, i)
								root.map.infowindow_close()
								functions.hide();
							} else {
								functions.show();
							}
						})


				},
				show: function () {
					vegetableObj
						.selectAll('.vegetable')
						.transition()
						.duration(400)
						.ease('cubic-out')
						.attr('transform', function (d, i) {
							return 'translate(' + (i * 160) + ', 0)';
						})
						.attr('opacity', 1)
						.each('end', function (d, i) {
							if (i === functions.length - 1) {
								functions.is_open = true;
							}
						})

					arrow_obj.obj
						.transition()
						.duration(400)
						.ease('cubic-out')
						.attr('transform', 'translate(' + (arrow_obj.x + 75) + ', ' + arrow_obj.y + ')')
						.attr('opacity', 0)
				},
				// alias
				set: function () {
					functions.hide();
				},
				hide: function (delay_time, decay_time) {
					vegetableObj
						.selectAll('.vegetable')
						.attr('opacity', function (d, i) {
							return 1;
						})
						.transition()
						.delay(delay_time || 0)
						.duration(decay_time || 400)
						.ease('cubic-out')
						.attr('opacity', function (d, i) {
							return obj.selected === i ? 1 : 0;
						})
						.attr('transform', function (d, i) {
							return 'translate(' + ((functions.length - 1) * 160) + ', 0)';
						})
						.each('end', function (d, i) {
							if (i === functions.length - 1) {
								functions.is_open = false;
							}
						})

					arrow_obj.obj
						.transition()
						.duration(400)
						.ease('cubic-out')
						.attr('transform', 'translate(' + arrow_obj.x + ', ' + arrow_obj.y + ')')
						.attr('opacity', 1)
				}
			}
			bind();
			var thisArray = [];
			for (var item in root.data.dataset[obj.selected].data[InfoGraphic.setting.year.name[InfoGraphic.setting.year.selected]]) {
				thisArray.push(item)
			}
			functions.length = thisArray.length
			functions.build(thisArray);
			adjust();
			functions.hide(700, 1200)

			return functions;
		},
	}
	return obj;
}
// ------------------------------------------------------------------------------------------------------------
InfoGraphic.data = function () {
	var obj = {
		dataset: null,
		load: function (callback) {
			InfoGraphic.logo.start();
			var url = 'nihonnoyasai.json?' + Math.random();
			d3.json(url, function (error, data) {
				obj.dataset = data;
				callback()
			})
			return this.dataset;
		},
		to_front: function (d, i) {
			var self = this,
				pre = this.dataset.slice(0, i),
				post = this.dataset.slice(i + 1);

			return pre.concat(post, d);
		}
	}
	return obj;
}
// ------------------------------------------------------------------------------------------------------------
InfoGraphic.bubble = function () {
	var root = InfoGraphic;

	var diameter = 400,
		format = d3.format(",d"),
		color = d3.scale.category20c();

	var obj = {
		style: {
			wapper_r: 0
		},
		init: function () {
			this.detail = d3.layout.pack()
				.sort(null)
				.size([root.detailsize, root.detailsize])
				.padding(0);

			this.build()
		},
		build: function (d, i) {
			// dummyオブジェクト
			var newobj = {
				children: [
					{ name: 'tomato', value: 99999999 },
					{ name: 'potato', value: 99999999 },
					{ name: 'daikon', value: 99999999 },
					{ name: 'nasu', value: 99999999 },
					{ name: 'pepper', value: 99999999 }
				]
			}
			this.wrapper = root.svg.select('#bubble')

			// group初期化
			this.group = this.wrapper
				.selectAll('g')
				.data(this.detail.nodes(newobj))
				.enter()
				.append("g")
				.attr('class', 'group')
				.attr("transform", function (d) {
					return "translate(" + d.x + "," + d.y + ")";
				})

			// circle
			this.group
				.data(this.detail.nodes(newobj))
				.append("circle")
				.attr("r", function (d) {
					if (d.children) {
						return d.r;
					}
					return d.r;
				})
				.style("fill", function (d) {
					if (d.depth === 0) { return '#C3BDA3' }
					return '#FFFFFF'
				})
				.on('click', function (d, i) {
					obj.select(d, i - 1);
				})


			// icon
			this.icons = this.group
				.filter(function (d) { return !d.children; })
				.append('g')
				.attr('class', function (d) {
					return 'icon icon_' + d.name
				})
				.on('click', function (d, i) {
					obj.select(d, i);
				})

			this.draw();

			this.group
				.filter(function (d) {
					return !d.children;
				})
				.append("text")
				.attr('class', 'value')
				.style("text-anchor", "middle")
				.on('click', function (d, i) {
					obj.select(d, i);
				})

			root.svg.select('#bubble')
				.attr('opacity', 0)

			// infotitle
			var year_name = InfoGraphic.setting.year.name[InfoGraphic.setting.year.selected]
			this.bubbleTitle = this.wrapper
				.selectAll('.info_detail')
				.data([0])
				.enter()
				.append('g')
				.attr('class', 'info_detail')


			this.bubbleTitle
				.append('path')
				.attr('class', 'title')
				.attr('d', 'M98.001,30.835c0-17.03-21.938-30.835-49-30.835S0,13.805,0,30.835c0,15.894,19.113,28.976,43.665,30.65 l5.336,16.29l5.336-16.29C78.888,59.811,98.001,46.729,98.001,30.835z')
				.attr('fill', '#FFFFFF')

			this.bubbleTitle
				.append("text")
				.attr("dy", ".75em")
				.attr("y", 24)
				.attr("x", 49)
				.style('fill', '#725D1E')
				.style("text-anchor", "middle")
				.style("font-size", "20px")
				.style("font-weight", "bold")
				.style('display', 'block')
				.attr("text-anchor", "middle")
		},
		draw: function () {
			this.icons
				.each(function (d) {
					var thisicon = obj.group.selectAll('.icon_' + d.name)
					switch (d.name) {
						case 'potato':
							thisicon.append('path')
								.attr('d', 'M70,33.588c0,5.77-0.088,13.334-2.812,17.992c-2.807,4.805-10.318,7.182-15.172,9.963 c-4.707,2.693-10.484,2.451-16.312,2.451S24.824,63,20.117,60.305c-4.856-2.779-8.82-6.363-11.631-11.166 C5.762,44.482,0,39.355,0,33.588c0-5.77,4.5-11.611,7.227-16.268c2.809-4.805,8.586-6.725,13.44-9.504 C25.373,5.123,29.875,0,35.703,0s12.764,0.959,17.471,3.654c4.857,2.779,6.611,9.77,9.418,14.572C65.318,22.885,70,27.822,70,33.588 z')
								.attr('class', 'color_01');
							thisicon.append('path')
								.attr('d', 'M20.217,36.26c-0.525,0.988-1.395,1.906-2.545,2.572c-2.648,1.533-5.752,1.158-6.939-0.844 c-0.029-0.051-0.053-0.105-0.08-0.156c-0.686,1.285-0.777,2.699-0.101,3.832c1.182,2.004,4.293,2.379,6.939,0.844 C20.07,41.008,21.254,38.252,20.217,36.26z')
								.attr('class', 'color_02');
							thisicon.append('path')
								.attr('d', 'M55.064,18.906c-0.123,2.024-0.875,4.191-2.275,6.145c-3.232,4.512-8.676,6.185-12.156,3.738 c-0.088-0.06-0.168-0.129-0.254-0.199c-0.158,2.646,0.76,5.057,2.732,6.441c3.479,2.439,8.922,0.768,12.152-3.742 C58.412,26.895,58.297,21.441,55.064,18.906z')
								.attr('class', 'color_02');
							thisicon.append('path')
								.attr('d', 'M37.102,21.695c-1.299,0.713-2.93,1.104-4.682,1.016c-4.043-0.203-7.191-2.842-7.035-5.896 c0.002-0.078,0.016-0.154,0.025-0.23c-1.695,0.93-2.828,2.424-2.914,4.152c-0.158,3.053,2.994,5.695,7.033,5.895 C33.469,26.83,36.793,24.637,37.102,21.695z')
								.attr('class', 'color_02');
							thisicon.attr('transform', function (d) {
								var zoom = d.r / 71
								return 'translate(' + (-71 * zoom / 2) + ',' + (-65 * zoom / 2) + ') scale(' + zoom + ')';
							})

							break;
						case 'daikon':
							thisicon.append('path')
								.attr('d', 'M52.327,24.905L62,13.369l-5.308-4.456l-7.884,9.396C50.443,20.293,51.627,22.539,52.327,24.905z')
								.attr('class', 'color_01');
							thisicon.append('path')
								.attr('d', 'M51.382,4.456L46.074,0l-9.672,11.532c2.448,0.279,4.864,1.056,7.099,2.322L51.382,4.456z')
								.attr('class', 'color_01');
							thisicon.append('path')
								.attr('d', 'M46.365,15.83c0.908,0.762,1.715,1.597,2.443,2.479l7.884-9.396l0.001-0.001l-5.31-4.457l-0.001,0.001 l-7.881,9.399C44.495,14.418,45.457,15.068,46.365,15.83z')
								.attr('class', 'color_02');
							thisicon.append('path')
								.attr('d', 'M48.808,18.31c-0.727-0.882-1.535-1.717-2.443-2.479c-0.908-0.762-1.87-1.412-2.864-1.976 c-2.235-1.266-4.65-2.043-7.099-2.322c-5.916-0.674-12.001,1.496-16.066,6.341c-6.5,7.746-26.398,44.447-18.518,51.062 c7.875,6.606,40.557-19.365,47.051-27.109c4.065-4.843,5.146-11.212,3.458-16.922C51.627,22.539,50.443,20.293,48.808,18.31z')
								.attr('class', 'color_03');
							thisicon
								.attr('transform', function (d) {
									// 71x65
									var zoom = d.r / 62
									var x = -62 * zoom / 2;
									var y = -70 * zoom / 2;
									return 'translate(' + x + ',' + y + ') scale(' + zoom + ')';
								})

							break;
						case 'tomato':
							thisicon.append('path')
								.attr('d', 'M35,62.136c-19.328,0-35-14.626-35-32.668C0,11.427,15.672,3.029,35,3.029c19.332,0,35,8.398,35,26.438	C70,47.51,54.332,62.136,35,62.136')
								.attr('class', 'color_01');

							thisicon.append('path')
								.attr('d', 'M49.82,10.766 38.5,10.766 35,0 31.508,10.766 20.184,10.766 29.344,17.538 25.844,28.422 35,21.752 44.16,28.373 40.66,17.546')
								.attr('class', 'color_02');

							thisicon
								.attr('transform', function (d) {
									// 71x65
									var zoom = d.r / 70
									var x = -70 * zoom / 2;
									var y = -62 * zoom / 2;
									return 'translate(' + x + ',' + y + ') scale(' + zoom + ')';
								})
							break;
						case 'pepper':
							thisicon.append('path')
								.attr('d', 'M23.39,59.81l-4.645-31.866c-0.912-6.271,1.866-12.217,6.689-15.676c-4.126-2.697-9.41-3.533-14.427-1.786 C2.446,13.471-2.071,22.824,0.927,31.373l10.65,30.397c1.674,4.756,6.323,8.078,11.638,7.828c1.991-0.093,3.841-0.681,5.441-1.634 C25.832,66.145,23.882,63.171,23.39,59.81z')
								.attr('class', 'color_01');
							thisicon.append('path')
								.attr('d', 'M41.346,10.477V0h-13v10.609c1.34-0.593,2.773-1.03,4.295-1.251C35.704,8.914,38.685,9.362,41.346,10.477z')
								.attr('class', 'color_01');
							thisicon.append('path')
								.attr('d', 'M58.99,10.482c-5.015-1.747-10.298-0.911-14.423,1.786c3.502,2.506,6.024,6.365,6.693,10.957 c0.23,1.58,0.213,3.213,0,4.719L46.617,59.81c-0.509,3.49-2.517,6.386-5.272,8.156c1.601,0.953,3.45,1.54,5.442,1.633 c5.31,0.25,9.965-3.072,11.637-7.828l10.649-30.397C72.071,22.824,67.555,13.471,58.99,10.482z')
								.attr('class', 'color_01');
							thisicon.append('path')
								.attr('d', 'M46.617,59.81l4.643-31.866c0.213-1.506,0.23-3.139,0-4.719c-0.669-4.592-3.191-8.451-6.693-10.957 c-1-0.715-2.081-1.312-3.221-1.79c-2.66-1.116-5.641-1.563-8.705-1.119c-1.521,0.221-2.955,0.658-4.295,1.251 c-1.034,0.458-2.009,1.012-2.91,1.659c-4.823,3.458-7.602,9.405-6.689,15.676L23.39,59.81c0.492,3.362,2.441,6.335,5.265,8.156 c1.369,0.883,2.942,1.499,4.659,1.749c2.917,0.423,5.733-0.272,8.031-1.749C44.1,66.196,46.108,63.299,46.617,59.81z')
								.attr('class', 'color_02');
							thisicon
								.attr('transform', function (d) {
									// 71x65
									var zoom = d.r / 70
									var x = -70 * zoom / 2;
									var y = -70 * zoom / 2;
									return 'translate(' + x + ',' + y + ') scale(' + zoom + ')';
								})


							break;
						case 'nasu':
							thisicon.append('path')
								.attr('d', 'M57.729,16.531c4.303,11.381-4.783,30.922-9.896,38.357c-6.766,9.838-20.531,17.572-32.914,14.383 C3.278,66.273-2.043,55.598,0.715,44.601c1.5-5.979,5.434-9.65,10.562-12.582c5.957-3.398,16.775-5.123,21.484-9.891 c3.77-3.818,6.037-9.269,11.225-11.482C49.676,8.217,55.666,11.08,57.729,16.531z')
								.attr('class', 'color_01');

							thisicon.append('path')
								.attr('d', 'M55.786,8.076l2.229-6.248L53.088,0l-2.24,6.29c-4.349-0.466-8.866,1.53-12.988,2.733l7.102,4.23L41.807,21 l7.664-3.027l3.965,7.348l2.463-8.006L64,18.73C61.41,14.818,59.587,10.55,55.786,8.076z')
								.attr('class', 'color_02');

							thisicon
								.attr('transform', function (d) {
									// 71x65
									var zoom = d.r / 64
									var x = -64 * zoom / 2;
									var y = -70 * zoom / 2;
									return 'translate(' + x + ',' + y + ') scale(' + zoom + ')';
								})
							break;

					}
				})
		},
		redraw: function () {

			this.icons
				.each(function (d) {
					d3.select(this)
						.selectAll('path')
						.attr('fill', 'red')
				})
		},
		load: function (d, i) {
			var year_name = InfoGraphic.setting.year.name[InfoGraphic.setting.year.selected]
			var vege_name = InfoGraphic.vegetables.name.en[InfoGraphic.vegetables.selected]
			var d = root.setting.pref.selected;
			if (!d) { return false; }
			if (d.data[year_name][vege_name] == 0) {
				root.map.zoom_out()
			}

			this.bgcolor = getcolor(d.data[year_name][vege_name]);
			if (!d.data[year_name][vege_name]) { return false; }

			// data整形
			var thisarray = []
			for (var key in d.data[year_name]) {
				thisarray.push({
					name: key,
					value: d.data[year_name][key]
				})
			}
			var newobj = { children: thisarray }

			// dataセット
			var thisgroup = root.svg.select('#bubble')
				.selectAll('.group')
				.data(this.detail.nodes(newobj))

			this.update(thisgroup)
			obj.set_text()
			obj.info_pref(d)
		},
		update: function (thisgroup) {
			// bubble positionセット
			thisgroup
				.transition()
				.duration(1000)
				.ease('bounce-in', 3)
				.attr("transform", function (d) { return "translate(" + d.x + "," + d.y + ") scale(1)"; })
				.select('circle')
				.attr('r', function (d) { return d.r })
				.attr('r', function (d) {
					if (d.children) {
						obj.style.wapper_r = d.r + 20;
						return d.r + 20;
					} else {
						return d.r;
					}
				})
				.style('fill', function (d) { return d.children ? obj.bgcolor : '#FFFFFF'; })


			// iconサイズ・ポジション
			thisgroup
				.select('.icon')
				.classed('selected', function (d) {
					return InfoGraphic.vegetables.selected_name === d.name;
				})
				.transition()
				.duration(600)
				.attr('transform', function (d) {
					var zoom = d.r / 70
					var x = -70 * zoom / 2;
					var y = -70 * zoom / 2;
					return 'translate(' + x + ',' + y + ') scale(' + zoom + ')';
				})
		},
		set_text: function () {

			//select
			root.svg.select('#bubble')
				.selectAll('.group')
				.select('.value')

				//initialize
				.attr('opacity', 0)
				.style('display', 'none')

				// wait
				.transition()
				.delay(800)
				// show
				.style('display', 'block')
				.text(function (d) {
					if (d.r >= 50) {
						return format(d.value) + 't';
					}
				})

				// style
				.style('fill', '#725D1E')
				.style("font-size", "15px")
				// .style("font-weight", "bold")
				.attr("dy", function (d) {
					return (d.r / 2) + 15;
				})

				// fadeIn
				.transition()
				.duration(200)
				.attr('opacity', 1)

		},
		close_button: function () {
			var functions = {
				init: function () {
					this.build();
				},
				build: function () {
					root.svg.select('#bubble')
						.selectAll('.close')
						.remove()

					var target =
						root.svg.select('#bubble')
							.append('g')
							.attr('class', 'close')
							.attr('transform', 'translate(' + (obj.style.wapper_r - 45) + ', ' + (obj.style.wapper_r * 2 - 50) + ')')
							.on('click', function () {
								root.map.zoom_out()
							})

					target
						.append('circle')
						.attr('cx', '24.876')
						.attr('cy', '24.876')
						.attr('r', '24.876')
						.attr('fill', '#FFFFFF')

					target
						.append('polygon')
						.attr('points', '37.763,15.657 34.095,11.989 24.876,21.207 15.657,11.989 11.989,15.657 21.207,24.876 11.989,34.095 15.657,37.763 24.876,28.545 34.095,37.763 37.763,34.095 28.545,24.876 ')
						.attr('fill', '#735E1F')
				},
				bind: function () {
					d3.select(this)
						.on('click', function () {

						})
				},
				adjust: function () {

				},
			}
			functions.init();
			return functions;
		},
		info_pref: function (d) {
			this.bubbleTitle
				.style('display', 'none')
				.attr('transform', function (d, i) { return 'translate(' + (root.detailsize / 2) + ', ' + (0) + ') scale(0.01)' })
				.transition()
				.delay(1000)
				.transition()
				.ease('cubic-out')
				.duration(300)
				.style('display', 'block')
				.attr('transform', function (d, i) { return 'translate(' + (root.detailsize / 2 - 50) + ', ' + (-70) + ') scale(1)' })
				.selectAll('text')
				.style('display', 'block')
				.attr("dy", ".75em")
				.attr("y", 24)
				.attr("x", 49)
				.style('fill', '#725D1E')
				.text(function () {
					return d.namae;
				})
		},
		zoom_in: function (d_from, i) {
			if (root.map.is_zoom) { return false; }
			var thisY = (d_from.position.y * root.style.zoom) + root.map.position.y
			var thisX = (d_from.position.x * root.style.zoom) + root.map.position.x

			var bubbles = root.svg.select('#bubble')
				.style('display', 'block')
				.attr('opacity', 1)
				.transition()
				.duration(10)
				.selectAll('path')


			root.svg.select('#bubble')
				.attr("transform", function (d) {
					return "translate(" + thisX + ', ' + thisY + ") scale(0.001)";
				})
				.transition()
				.duration(1000)
				.ease('bounce-in', 3)
				.attr("transform", function (d) {
					return "translate(" + (root.style.width / 2 - root.detailsize / 2) + ", " + (root.style.height / 2 - root.detailsize / 2) + ") scale(1)";
				})

			obj.close_button()
			obj.is_zoom = true;
		},
		zoom_out: function (d_from, i) {
			if (d_from === null) {
				return false;
			}
			var thisY = (d_from.position.y * root.style.zoom) + root.map.position.y
			var thisX = (d_from.position.x * root.style.zoom) + root.map.position.x

			root.svg.select('#bubble')
				.selectAll('.group').interrupt()

			var thisgroup = root.svg.select('#bubble')

			// text非表示
			thisgroup.selectAll('text')
				.style('display', 'none')


			thisgroup
				.attr("transform", function (d) {
					return "translate(" + (root.style.width / 2 - root.detailsize / 2) + ", " + (root.style.height / 2 - root.detailsize / 2) + ") scale(1)";
				})
				.transition()
				.duration(350)
				.ease('cubic-out', .3)
				.attr("transform", function (d) {
					return "translate(" + thisX + ', ' + thisY + ") scale(0)";
				})
				.each('end', function () {
					d3.select(this)
						.style('display', 'none')
				})
			obj.is_zoom = false;
		},
		select: function (d, i) {
			this.selected_name = d.name;
			this.selected = i;

			if (d.children) {
				root.map.zoom_out()
			} else {
				root.vegetables.select(d.name, i)
			}
		}

	}
	obj.init();
	return obj;
}
// ------------------------------------------------------------------------------------------------------------
InfoGraphic.map = function () {
	var root = InfoGraphic;
	var obj = {
		is_zoom: null,
		is_hover: {
			name: null
		},
		is_play: false,
		position: {
			x: 0,
			y: 0
		},
		style: {
			marginTop: 50,
			padding: 180,
			width: 660,
			height: 540,
			boxwidth: 980,
		},
		selected: null,
		init: function () {
			this.circles = root.viewport.select('#circles');
			this.infoarea = root.viewport.select('#info');
			this.hitarea = root.viewport.select('#hitarea');
			this.details = root.viewport.select('#details');
			this.format_number = d3.format(",d");
			this.build();
			this.adjust();
			this.bind();
		},
		adjust: function () {
			// zoom 縦横小さい方
			root.style.zoom = Math.min(Math.min(555, root.style.width / (obj.style.boxwidth + obj.style.padding)), Math.min(555, root.style.height / (obj.style.height + obj.style.padding)));
			obj.position.x = Math.max(root.style.width / root.style.zoom / 2 - obj.style.boxwidth / 2 + 40 * root.style.zoom);
			obj.position.y = Math.max(0, root.style.height / root.style.zoom / 2 - obj.style.height / root.style.zoom / 2) + obj.style.marginTop;
			root.viewport.attr('transform', 'translate(' + obj.position.x + ', ' + obj.position.y + ') scale(' + root.style.zoom + ')')
		},
		build: function () {
			var year_name = InfoGraphic.setting.year.name[InfoGraphic.setting.year.selected]
			var vege_name = InfoGraphic.vegetables.name.en[InfoGraphic.vegetables.selected]

			// グループとサークル生成
			var g_circle = this.circles
				.selectAll('circle')
				.data(root.data.dataset)
				.enter()

			g_circle
				.append('circle')
				.attr('class', 'graphic')
				.attr('r', function (d, i) { return Math.random() * 200; })
				.attr('fill', '#E4E4DA')
				.attr('cx', function (d, i) { return d.position.x })
				.attr('cy', function (d, i) { return (Math.random() * 4000 - 4000) })
				// transition --------------------------
				.transition()
				.duration(function (d, i) { return Math.random() * 2000 + 500 })
				.ease('cubic-out')
				.attr('cx', function (d, i) { return d.position.x })
				.attr('cy', function (d, i) { return d.position.y })
				.attr("r", function (d) {
					// testmode constant R
					if (location.hash == "#r_const") {
						return 20;
					}
					return obj.scale(d.data[year_name][vege_name]);
				})
				.attr("fill", function (d) { return getcolor(d.data[year_name][vege_name]); })

			g_circle
				.append('polygon')
				.attr('class', 'pointer')
				.attr('points', '24.505,0 12.253,21.222 0,0')
				.attr('fill', '#fff')
				.attr('opacity', 0)
				.attr('transform', function (d) {
					return 'translate(' + (d.position.x - 7 / 2) + ', ' + (d.position.y - 7 / 2) + ') scale(.3)';
				})
			// infowindow生成
			var allinfo = this.infoarea
				.selectAll('g')
				.data(root.data.dataset)
				.enter()
				.append('g')
				.attr('class', function (d) {
					return 'info_' + d.name
				})

			// 吹き出し背景
			allinfo
				.attr('transform', function (d, i) { return 'translate(' + (d.position.x) + ', ' + (d.position.y) + ') scale(0)' })
				.append('path')
				.attr('d', 'M98.001,30.835c0-17.03-21.938-30.835-49-30.835S0,13.805,0,30.835c0,15.894,19.113,28.976,43.665,30.65 l5.336,16.29l5.336-16.29C78.888,59.811,98.001,46.729,98.001,30.835z')
				.attr('fill', '#FFFFFF')

			allinfo
				.append("text")
				.attr("dy", ".75em")
				.attr("y", 16)
				.attr("x", 49)
				.style('fill', '#725D1E')
				.style("text-anchor", "middle")
				.style("font-size", "20px")
				.style("font-weight", "bold")
				.attr("text-anchor", "middle")
				.text(function (d) { return d.namae; });

			allinfo
				.append("text")
				.attr("dy", ".75em")
				.attr("y", 38)
				.attr("x", 49)
				.style('fill', '#725D1E')
				.style("font-size", "12px")
				.attr('class', 'value')
				.attr("text-anchor", "middle")

			// マウスエリア追加
			this.hitarea
				.selectAll('circle')
				.data(root.data.dataset)
				.enter()
				.append('circle')
				.attr('class', 'area')
				.attr('cx', function (d, i) { return d.position.x })
				.attr('cy', function (d, i) { return d.position.y })
				.attr('r', function (d, i) { return 20; })
				.attr('opacity', 0)

		},
		draw: function (animate) {
			var year_name = InfoGraphic.setting.year.name[InfoGraphic.setting.year.selected]
			var vege_name = InfoGraphic.vegetables.name.en[InfoGraphic.vegetables.selected]

			if (animate) {
				this.circles
					.selectAll('circle')
					.data(root.data.dataset)
					.transition()
					.delay(function (d, i) { return Math.random() * 10 })
					.duration(function (d, i) { return Math.random() * 700 + 200; }) // build時は引数falseでアニメーション無し
					.ease('cubic-out')
					.attr('cx', function (d, i) { return d.position.x })
					.attr('cy', function (d, i) { return d.position.y })
					.attr("r", function (d) {
						return obj.scale(d.data[year_name][vege_name]);
					})
					.attr("fill", function (d) { return getcolor(d.data[year_name][vege_name]); })

			} else {
				this.circles
					.selectAll('circle')
					.data(root.data.dataset)
					.attr("r", function (d) {
						// testmode constant R
						if (location.hash == "#r_const") {
							return 20;
						}
						return obj.scale(d.data[year_name][vege_name]);
					})
			}
		},
		scale: function (i) {
			var scale = d3.scale
				.pow()
				.exponent(.4)
				.domain([0, 1500000])
				.range([5, 100])
			return scale(i)
		},
		bind: function () {
			// ヒットエリア
			this.hitarea
				.selectAll('circle')
				.on('click', function (d, i) {
					if (obj.is_hover === d || obj.is_zoom) {
						this.is_play = false;
						obj.click(d, i);
						obj.is_hover = null;
						obj.togglePointer(false)
					} else {
						obj.infowindow(d, i);
						obj.is_hover = d;
						obj.togglePointer(d, i)
					}
				})
				.on('mouseover', function (d, i) {
					if (obj.is_hover === null) return false;
					if (d.name !== obj.is_hover.name) {
						obj.infowindow(d, i);
						obj.is_hover = d;
						obj.togglePointer(d, i)
					}
				})
				.on('touchstart', function (d, i) {
					obj.infowindow(d, i);
					obj.togglePointer(d, i)
				})

			// サークル本体
			this.circles
				.selectAll('circle')
				.on('click', function (d, i) {
					if (obj.is_hover === d || obj.is_zoom) {
						this.is_play = false;
						obj.click(d, i);
					} else {
						obj.infowindow(d, i);
						obj.is_hover = d;
						obj.togglePointer(d, i)
					}
				})
				.on('mouseover', function (d, i) {
					if (obj.is_hover === null) return false;

					var hover = obj.is_hover.name || null;
					if (d.name !== obj.is_hover.name) {
						obj.infowindow(d, i);
						obj.is_hover = d;
						obj.togglePointer(d, i)
					}
				})
			// マウスアウト処理（toelement必要なのでjquery)
			$('#circles, #hitarea').on('mouseout', function (e) {
				if ($(e.relatedTarget).attr('id') == 'svg') {
					obj.infowindow_close();
				}
			})
			$(window).on('resize', obj.adjust)
		},

		togglePointer: function (d, i) {
			var year_name = InfoGraphic.setting.year.name[InfoGraphic.setting.year.selected]
			var vege_name = InfoGraphic.vegetables.name.en[InfoGraphic.vegetables.selected]
			this.circles
				.selectAll('.pointer')
				.transition()
				.duration(200)
				.attr('opacity', function (d) {
					return obj.is_hover === d ? 1 : 0;
				})
		},
		infowindow: function (d, i) {
			var year_name = InfoGraphic.setting.year.name[InfoGraphic.setting.year.selected]
			var vege_name = InfoGraphic.vegetables.name.en[InfoGraphic.vegetables.selected]
			this.infoarea
				.selectAll('text')
				.attr('display', 'none')
			this.infoarea
				.selectAll('g')
				.transition()
				.duration(100)
				.attr('transform', function (d2) {
					if (!obj.is_zoom && d === d2) {
						return 'translate(' + (d2.position.x - 49) + ', ' + (d2.position.y - 78 - obj.scale(d.data[year_name][vege_name]) * .5) + ') scale(1)'
					} else {
						return 'translate(' + (d2.position.x) + ', ' + (d2.position.y) + ') scale(0)'
					}
				})
				.selectAll('text')
				.transition()
				.attr('display', 'block')
				.attr('opacity', '1')
			this.infoarea
				.selectAll('.value')
				.text(function (d) { return obj.format_number(d.data[year_name][vege_name]) + 't' });
			this.infoarea
				.selectAll('path')
				.style('fill', '#fff')

		},
		infowindow_close: function (d, i) {
			obj.infowindow(false);
			obj.is_hover = false;
			obj.togglePointer(false)
			this.is_hover = false;
		},
		// map click関連
		click: function (d, i) {
			var year_name = InfoGraphic.setting.year.name[InfoGraphic.setting.year.selected]
			var vege_name = InfoGraphic.vegetables.name.en[InfoGraphic.vegetables.selected]

			if (d.data[year_name][vege_name] == 0) {
				return false;
			}

			root.setting.pref.selected = d;
			obj.infowindow(false);

			root.bubble.load(d, i)
			root.data.dataset = root.data.to_front(d, i);

			this.update(d, i)
			this.draw(false)

			if (this.selected === d) {
				this.zoom_out(this);
				return false;
			} else {
				root.bubble.zoom_in(d, i);
				obj.zoom_in(d, i);
			}
			this
				.circles
				.selectAll('circle')
				.classed("deactive", function (d2) {
					return d !== d2
				});

			this.selected = d;
		},
		update: function (d, i) {
			var year_name = InfoGraphic.setting.year.name[InfoGraphic.setting.year.selected]
			var vege_name = InfoGraphic.vegetables.name.en[InfoGraphic.vegetables.selected]
			this.circles
				.selectAll('circle')
				.data(root.data.dataset)
				.attr("cx", function (d) { return d.position.x; })
				.attr("cy", function (d) { return d.position.y; })
				.attr("fill", function (d) { return getcolor(d.data[year_name][vege_name]) })

			this.hitarea
				.selectAll('circle')
				.data(root.data.dataset)
				.attr("cx", function (d) { return d.position.x; })
				.attr("cy", function (d) { return d.position.y; })
		},
		zoom_in: function (d, i) {
			var self = this;
			var year_name = InfoGraphic.setting.year.name[InfoGraphic.setting.year.selected]
			var vege_name = InfoGraphic.vegetables.name.en[InfoGraphic.vegetables.selected]
			var zoom_ratio = (root.detailsize /* padding */) / this.scale(d.data[year_name][vege_name]) / 2;

			// 拡大アニメーション ------------------------------------------------------------------------------------
			if (this.is_zoom === null) {
				d3.select('.active')
					.transition()
					.ease('cubic-in')
					.duration(400)
					.transition()
					.duration(300)
					.ease('cubic-in')
					.attr("transform", "scale(1)")
			}

			// ズーム+移動処理 ------------------------------------------------------------------------------------
			root.viewport
				.transition()
				.ease('bounce-in', 0.2)
				.duration(1000)
				.attr("transform", "translate(" + root.style.width / 2 + "," + root.style.height / 2 + ")scale(" + zoom_ratio + ")translate(" + -d.position.x + "," + -d.position.y + ")")
				.selectAll('circle')

			// スタートアニメーション強制オフ
			this.circles
				.transition()
				.duration(0)
				.selectAll('.graphic')
				.attr('cx', function (d, i) { return d.position.x })
				.attr('cy', function (d, i) { return d.position.y })
				.attr("r", function (d) {
					return obj.scale(d.data[year_name][vege_name]);
				})
				.attr("fill", function (d) { return getcolor(d.data[year_name][vege_name]); })


			this.is_zoom = true;
		},
		zoom_out: function () {
			root.bubble.zoom_out(this.selected || null)
			root.viewport
				.transition()
				.duration(350)
				.ease('cubic-out', .3)
				.attr('transform', 'translate(' + obj.position.x + ', ' + obj.position.y + ') scale(' + root.style.zoom + ')')
			this.selected = null;
			this.is_zoom = null;
			obj.is_hover = false;
			root.setting.pref.selected = null;
		}
	}
	return obj;
}
// ------------------------------------------------------------------------------------------------------------
InfoGraphic.timemachine = function () {
	var root = InfoGraphic;
	var adjust = function () {
		if (root.style.width / 840 <= 1) {
			functions.zoom = root.style.width / 840
		}
		obj.style.x = (root.style.width - obj.style.width - obj.style.right)
		obj.style.y = (root.style.height - obj.style.height - obj.style.bottom)
		d3.select('#timetable')
			.attr('transform', 'translate(' + obj.style.x + ', ' + obj.style.y + ') scale(1)')
	}
	var bind = function () {
		$(window).on('resize', adjust)

		// touchmove
		document.getElementById('timetable').addEventListener('touchmove', function(event) {
			obj.select(event.originalEvent.touches[0].clientY - obj.style.y)
		}, {passive: true})
		document.getElementById('timetable').addEventListener('touchstart', function(event) {
			obj.select(event.originalEvent.touches[0].clientY - obj.style.y)
		}, {passive: true})
		$('#timetable').on('mousedown', function (event) {
			obj.is_drag = true;
			obj.select(event.clientY - obj.style.y)

			$(window).on('mousemove', function (event) {
				obj.select(event.clientY - obj.style.y)
			});

			$(window).on('mouseup', function () {
				obj.is_drag = false;
				$(window).off('mousemove')
				$(window).off('mouseup')
			})
		})
	}
	var obj = {
		selected: 0,
		name: 'year_1974',
		label: [
			"year_1974",
			"year_1984",
			"year_1994",
			"year_2004",
			"year_2014",
			"year_2022",
		],
		mouse: {
			top: 23,
			bottom: 190
		},
		style: {
			x: 0,
			left: 20,
			right: 60,
			bottom: 300,
			sep: 42,
			height: 265,
			width: 146
		},
		init: function () {
			bind();

			d3.select('#timetable')
				.style('display', 'block')

			d3.select('#time_arrow')
				.attr('transform', 'translate(' + obj.style.left + ', ' + obj.mouse.top + ')')
				.style('display', 'block')

			adjust();
		},

		select: function (y) {
			root.map.infowindow_close();
			var thisselect = Math.max(Math.min(5, Math.floor(y / obj.style.height / 0.16666667)), 0);
			InfoGraphic.setting.year.selected = thisselect
			if (thisselect != obj.selected) {
				obj.trip(thisselect)
				obj.set_arrow(thisselect)
			}
		},
		set_arrow: function (index) {
			d3.select('#time_arrow')
				.transition()
				.ease('cubic-out')
				.duration(130)
				.attr('transform', 'translate(' + obj.style.left + ', ' + (index * obj.style.sep + obj.mouse.top) + ')');
		},
		// tmp
		random: function () {
			obj.trip(Math.ceil(Math.random() * obj.label.length));
		},
		trip: function (value) {
			root.bubble.load()
			this.selected = value;
			InfoGraphic.setting.year.selected = value;
			root.map.draw(true);
		}
	}
	return obj;
}
// ------------------------------------------------------------------------------------------------------------
InfoGraphic.logo = function () {
	var root = InfoGraphic;
	var obj = {
		style: {
			width: 125,
			height: 146,
			// ロゴ位置（アニメーション終了時）
			left: 80,
			top: 120
		},
		init: function () {
			this.logo = d3.select('#svg_logo');
			this.logo.attr('opacity', 0)
			this.splash();
			this.bind();
		},
		splash: function () {
			var self = this;
			this.logo
				.attr('transform', function (d) { return 'translate(' + (root.style.width / 2 - obj.style.width) + ', ' + (root.style.height / 2 - obj.style.height) + ') scale(2)' })
				.transition()
				.ease('cubic-in')
				.delay(200)
				.duration(300)
				.attr('opacity', 1)
		},
		bind: function () {
			this.logo
				.on('click', function () {
					root.map.zoom_out()
				})
		},
		start: function () {
			this.logo
				.transition()
				.ease('cubic-in')
				.duration(500)
				.delay(2000)
				.attr('transform', function (d) {
					return 'translate(' + (root.style.width / 2 - obj.style.width) + ', ' + root.style.height + ') scale(2)'
				})
				.each('end', function () {
					obj.logo.attr('transform', function (d) { return 'translate(' + (obj.style.left) + ', ' + (-obj.style.height - 40) + ') scale(1)' })
					obj.top_to_end();
					d3.select('#graph')
						.attr('transform', function (d) { return 'translate(' + (obj.style.left + 160) + ', ' + (-obj.style.height - 40) + ') scale(1)' })
				})

		},
		top_to_end: function () {
			this.logo
				.transition()
				.duration(500)
				.delay(200)
				.ease('cubic-out')
				.attr('transform', function (d) {
					return 'translate(' + (obj.style.left) + ', ' + obj.style.top + ')';
				})

			d3.select('#graph')
				.transition()
				.duration(500)
				.delay(200)
				.ease('cubic-out')
				.attr('transform', function (d) {
					return 'translate(' + (obj.style.left + 160) + ', ' + obj.style.top + ')';
				})
		}
	}
	return obj;
}
// ------------------------------------------------------
var getcolor = function (i) {
	if (i <= 1000) {
		return '#202D84';
	} else if (i <= 5000) {
		return '#377453';
	} else if (i <= 10000) {
		return '#7CB958';
	} else if (i <= 50000) {
		return '#FFF130';
	} else if (i <= 100000) {
		return '#FF9025';
	} else {
		return '#FF0000';
	}
}
// ------------------------------------------------------

$(function () {
	InfoGraphic.init();
});

